import { ModalAction } from 'store/types'

export type ModalType =
  | 'ActionsModal'
  | 'AttachmentsModal'
  | 'BulletinNotificationStatusModal'
  | 'BulletinSeeByModal'
  | 'BulletinSendNotificationsModal'
  | 'CommentsModal'
  | 'ContactListCreationModal'
  | 'ContactListHistoryModal'
  | 'ContactListSettingsModal'
  | 'ContactUserAddHistoryModal'
  | 'ContactUsersHistoryModal'
  | 'ContactUserTimesContactedModal'
  | 'CoworkerModal'
  | 'DailyQuestionnaireModal'
  | 'DeleteAffectsConfirmationModal'
  | 'DeleteAffectsConfirmationModal'
  | 'DeleteAffectsConfirmationModal'
  | 'DeleteButtonModal'
  | 'DeleteSearchPresetConfirmationModal'
  | 'DropDownDateFilterButtonModal'
  | 'DropDownFiltersButtonModal'
  | 'DropDownHeroFilterModal'
  | 'DropDownSavedPresetsModal'
  | 'EmployeeScheduleProjectInformationModal'
  | 'GeolocationConfirmationModal'
  | 'GeolocationRequestModal'
  | 'ImportantInformationModal'
  | 'MapModal'
  | 'ProfileImageZoomInModal'
  | 'ProfilePictureUploadModal'
  | 'PunchAddCommentModal'
  | 'PunchProjectTransferModal'
  | 'PunchInOutModal'
  | 'PunchInOutModalGeolocation'
  | 'ResetPasswordModal'
  | 'SaveSearchModal'
  | 'ScheduleAssignEmployeeModal'
  | 'ScheduleCancelModal'
  | 'ScheduleConfirmationsModal'
  | 'ScheduleConfirmChangesModal'
  | 'ScheduleConfirmPasteModal'
  | 'ScheduleCreateAttendance'
  | 'ScheduleDeleteModal'
  | 'ScheduleEditModal'
  | 'ScheduleFinalizeModal'
  | 'ScheduleFixUserEligibilityProblemsModal'
  | 'ScheduleFixUserEligibilityProblemsModal'
  | 'ScheduleHelpModal'
  | 'ScheduleHelpModal'
  | 'ScheduleHistoryModal'
  | 'ScheduleMobileActionsModal'
  | 'ScheduleMultiEditModal'
  | 'ScheduleNotesModal'
  | 'ScheduleOpenEmployeeSchedule'
  | 'SchedulePublishModal'
  | 'ScheduleRestoreModal'
  | 'ScheduleUnassignEmployeeModal'
  | 'ScheduleUnpublishModal'
  | 'TimeOffSCEModal'
  | 'UnreadBulletinModal'
  | 'UserDeleteModal'
  | 'UserOnboardingModal'

export function openModal(modalType: ModalType, modalProps?: unknown): { type: ModalAction.SHOW_MODAL; modalType: ModalType; modalProps: unknown } {
  return { type: ModalAction.SHOW_MODAL, modalType, modalProps }
}

export function closeModal(): { type: ModalAction.HIDE_MODAL } {
  return { type: ModalAction.HIDE_MODAL }
}

export function updateModal(modalType: ModalType, modalProps: unknown): { type: ModalAction.UPDATE_MODAL; modalType: ModalType; modalProps: unknown } {
  return { type: ModalAction.UPDATE_MODAL, modalType, modalProps }
}
